import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ScheduledDiscoveryResultDto } from "../Discovery/ScheduledDiscoveryResultDto";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";

export class GetSchedDiscResultsResultDto extends DtoBase {

	public Results: List<ScheduledDiscoveryResultDto>;

	constructor() {
		super();

		this.Results = new List<ScheduledDiscoveryResultDto>();
	}

	public get HasResults(): boolean {
		return (!!this.Results && this.Results.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.get_sched_disc_results_result = {};
		obj = obj.get_sched_disc_results_result;

		super.Write(obj, context);

		if (this.HasResults) {
			obj.results = [];
			ObjSerUtils.WriteObjSerCollection(obj.results, this.Results, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_sched_disc_results_result)
			throw new Error();
		obj = obj.get_sched_disc_results_result;

		super.Read(obj, context);

		if (obj.results !== undefined) {
			this.Results.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.results, this.Results, (value: any) => {
				return new ScheduledDiscoveryResultDto();
			}, context);
		}
	}

}